import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';
import { RELATED_PARTY_TYPES } from '../../../../../../../constants';

class RelatedPartyTypeEqualsTo implements Rule {
  private principalId: any;
  private type: (typeof RELATED_PARTY_TYPES)[keyof typeof RELATED_PARTY_TYPES];

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  public setType(
    type: (typeof RELATED_PARTY_TYPES)[keyof typeof RELATED_PARTY_TYPES]
  ) {
    this.type = type;
    return this;
  }

  private getPrincipal(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) => principal.id === this.principalId
    );
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const relatedParty = this.getPrincipal(application);
    const isSameType =
      relatedParty?.principal_type == (this.type as unknown as string);

    return isSameType ?? false;
  }
}

export default new RelatedPartyTypeEqualsTo();
